import React, { useEffect, useState } from 'react'
import { Segment, Worksite } from 'redux/employer/employerTypes'
import CommutersTable from '../MyCommuters/CommutersTable'
import SegmentsDrawer from '../components/SegmentsDrawer'
import { useSelector, useDispatch } from 'react-redux'
import { AppState } from 'redux/config/store'
import { employeeActions } from 'redux/employee/employeeSlice'
import SecondaryButton from 'core-system/Button/SecondaryButton'

interface SegmentInfoDrawerProps {
  type: 'worksite' | 'group'
  open: boolean
  closeModal: () => void
  segment?: Segment
  worksite?: Worksite
  commutersAddMode?: boolean
}

const SegmentInfoDrawer = (props: SegmentInfoDrawerProps) => {
  const dispatch = useDispatch()
  const {
    type,
    open,
    closeModal,
    segment,
    worksite,
    commutersAddMode = false,
  } = props

  const [isAdd, setIsAdd] = useState(commutersAddMode)
  const [isEdit, setIsEdit] = useState(false)

  useEffect(() => {
    setIsAdd(commutersAddMode)
  }, [commutersAddMode])

  const { myCommuters } = useSelector((state: AppState) => state.employee)
  const { segmentsType, segmentsMap, allEmployeeSegmentId } = useSelector(
    (state: AppState) => state.employer
  )

  const activeSegment = type === 'worksite' ? worksite?.segmentId : segment?.id
  const allEmployeesSegmentId =
    segmentsType?.all?.[0]?.id || allEmployeeSegmentId

  useEffect(() => {
    if (!open || !activeSegment) {
      return
    }
    if (!myCommuters?.[activeSegment]) {
      dispatch(employeeActions.getMyCommuters({ segment: activeSegment }))
    }
    if (
      isAdd &&
      allEmployeesSegmentId &&
      allEmployeesSegmentId !== activeSegment &&
      !myCommuters?.[allEmployeesSegmentId]
    ) {
      dispatch(
        employeeActions.getMyCommuters({ segment: allEmployeesSegmentId })
      )
    }
  }, [open, activeSegment, isAdd, allEmployeesSegmentId, myCommuters, dispatch])

  const getActiveCommuters = () => {
    if (isAdd) {
      return myCommuters?.[activeSegment] || []
    }
    return []
  }

  const segmentRoster = activeSegment ? myCommuters?.[activeSegment] : undefined
  const allEmployeesRoster = allEmployeesSegmentId
    ? myCommuters?.[allEmployeesSegmentId]
    : undefined
  const tableRoster = isAdd ? allEmployeesRoster : segmentRoster
  const rosterLoading = Boolean(open && !tableRoster)

  return (
    <SegmentsDrawer
      title={type === 'worksite' ? 'Worksite Details' : 'Group Details'}
      open={open}
      onCloseModal={closeModal}
      titleRightComponent={
        type === 'group' ? (
          <>
            <SecondaryButton
              onClick={() => setIsAdd(true)}
              disabled={isAdd || isEdit}
            >
              Add Commuters
            </SecondaryButton>
            <SecondaryButton
              onClick={() => setIsEdit(true)}
              disabled={isEdit || isAdd}
            >
              Manage Commuters
            </SecondaryButton>
          </>
        ) : (
          <></>
        )
      }
    >
      <CommutersTable
        myCommuters={tableRoster || []}
        activeCommuters={getActiveCommuters()}
        isAdd={isAdd}
        isEdit={isEdit}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        activeSegment={segmentsMap?.[activeSegment]}
        resetPaginationOnRowsChange={!(isAdd || isEdit)}
        isLoading={rosterLoading}
      />
    </SegmentsDrawer>
  )
}

export default SegmentInfoDrawer
